import * as React from 'react'
import MaskedTextInput from 'react-text-mask'

import { Field, TextField } from 'embed/constants'
import { ValidationData } from 'common/services/Validation'

export interface Props {
  field: Field
  validationData: ValidationData
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textFieldProps: any
  textInputClassName: string
  useFloatingLabelInputs?: boolean
}

export const TextInput: React.FC<Props> = (props) => {
  const { textInputClassName, textFieldProps, useFloatingLabelInputs } = props
  const textField = props.field as TextField
  const inputProps = { ...textFieldProps, value: textFieldProps.value as string }

  if (textField.options.mask) {
    return (
      <MaskedTextInput
        className={textInputClassName}
        mask={textField.options.mask}
        pipe={textField.options.pipe}
        required={useFloatingLabelInputs}
        {...inputProps}
      />
    )
  }

  return <input className={textInputClassName} required={useFloatingLabelInputs} {...inputProps} />
}
